import React, { useEffect, useState } from 'react'
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    Select, Button, Input, Grid, useToast,
} from '@chakra-ui/react'
import StudentsService from '../../API/StudentsService'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useStudentsStore } from '../../store/studentsStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import { useGlobalStore } from '../../store/globalStore'
import { useStudentsTagsModalStore } from '../../store/modalsStore'
import { RoleId } from '../../utils/constants'
import AdminService from '../../API/AdminService'

function AddTagModal({isOpen, onClose}) {
    const toast = useToast()

    const [student, purchase] = useStudentsTagsModalStore(state => [state.student, state.purchase])
    const user = useGlobalStore(state => state.user)
    const isAdmin = user?.active_context?.role?.id === RoleId.ADMIN
    const [purchaseTags, setPurchaseTags] = useStudentsStore(state => [state.purchaseTags, state.setPurchaseTags])
    const availableTags = purchase ? purchaseTags.filter(tag => !purchase.tags.map(t => t.id).includes(tag.id)) : []
    const updateStudent = useStudentsStore(state => state.updateStudent)

    const [currentTagIndex, setCurrentTagIndex] = useState(purchaseTags?.length > 0 ? 0 : undefined)
    const [newTag, setNewTag] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const createTag = useAccessAPI(AdminService.createPurchaseTag)
    const addTag = useAccessAPI(StudentsService.addPurchaseTag)

    useEffect(() => {
        setCurrentTagIndex(purchaseTags?.length > 0 ? 0 : undefined)
    }, [purchaseTags])

    const onAddTag = async () => {
        setIsLoading(true)
        const response = await addTag(purchaseTags[currentTagIndex].id, purchase.id)
        if (response?.status === 200) {
            updateStudent({...student, purchases: student.purchases.map((p) => {
                if (p.id === purchase.id)
                    p.tags.push(purchaseTags[currentTagIndex])
                return p
            })})
            onClose()
        } else {
            toast(toastError('Не удалось добавить тэг'))
        }
        setCurrentTagIndex(0)
        setIsLoading(false)
    }

    const onCreateTag = async () => {
        if (newTag.length < 3) {
            toast(toastError("Слишком короткий тэг"))
            return
        }

        setIsLoading(true)

        const response = await createTag(newTag)
        if (response?.status === 200) {
            setPurchaseTags([...purchaseTags, response.data])
            setNewTag('')
            toast(toastSuccess("Тэг успешно создан"))
        } else {
            toast(toastError("Не удалось создать новый тэг"))
        }

        setIsLoading(false)
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {isAdmin ? "Создние тега" : "Добавление тега"}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Grid gap='var(--default-gap)'>
                        {
                        isAdmin &&
                        <>
                            <Select
                                placeholder='Существующие теги'
                            >
                                {purchaseTags.map((tag) => (
                                    <option key={`extag${tag.id}`}>
                                        {tag.title}
                                    </option>
                                ))}
                            </Select>
                            <Input 
                                value={newTag}
                                placeholder='Название нового тега'
                                onChange={(event) => setNewTag(event.target.value)}
                            />
                        </>
                        }
                        {
                        !isAdmin &&
                        <Select onChange={(event) => setCurrentTagIndex(Number(event.target.value))}>
                            {availableTags.map((tag, index) => (
                                <option
                                    value={index}
                                    key={`tag${tag.id}`}
                                >
                                    {tag.title}
                                </option>
                            ))}
                        </Select>
                        }
                    </Grid>
                </ModalBody>

                <ModalFooter>
                    <Button onClick={onClose} mr="auto" variant='secondary'>
                        Отмена
                    </Button>
                    <Button 
                        isLoading={isLoading}
                        onClick={isAdmin ? onCreateTag : onAddTag}
                    >
                        {isAdmin ? "Создать" : "Добавить"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default AddTagModal
